// extracted by mini-css-extract-plugin
export default {"breadcrub_container":"index_breadcrub_container__n75My","createdSearch":"index_createdSearch__s6kMN","custom_table":"index_custom_table__90n9Q"};